<template>
    <div>
        <transition name="fade">
            <div class="panel panel-default" v-if="queue.length > 0">
                <div class="panel-heading">
                    <div class="level jc-sb ai-c">
                        <span>
                            Pending Imports
                        </span>
                    </div>
                </div>

                <div class="panel-body">
                    <table class="table has-mobile-cards">
                        <thead>
                            <tr>
                                <th>Vendor</th>
                                <th>Type</th>
                                <th>Account</th>
                                <th>Info</th>
                                <th>Queue</th>
                                <th>Cancel</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(item, idx) in queue" :key="idx">
                                <td data-label="Vendor">
                                    {{ item.vendor }}
                                </td>
                                <td data-label="Type">
                                    {{ formatImportType(item.type) }}
                                </td>
                                <td data-label="Account">
                                    {{ item.account }}
                                </td>
                                <td data-label="Info">
                                    <button class="btn btn-default" @click="showPendingItemInfo(item)" v-if="item.status == 'failed'">
                                        <span class="fa fa-question"></span>
                                    </button>
                                </td>
                                <td data-label="Queue">
                                    <button class="btn btn-default" @click="processQueueItem(item)" v-if="item.status != 'queued'">
                                        <span class="fa fa-refresh"></span>
                                    </button>
                                    <button class="btn btn-default" @click="processQueueItem(item)" v-else disabled>
                                        <span class="fa fa-clock-o"></span>
                                    </button>
                                </td>
                                <td data-label="Remove">
                                    <button class="btn btn-default" @click="removeQueueItem(item)" :disabled="item.status == 'queued'">
                                        <span class="fa fa-times"></span>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="panel-footer">
                    <div class="level jc-fe fd-r">
                        <button class="btn btn-primary mr-1" @click="processQueue()" :class="{'btn-loading': loading}" :disabled="loading">
                            <span class="fa fa-refresh"></span>
                             Queue All
                        </button>
                        <button class="btn btn-danger" @click="clearQueue()" :class="{'btn-loading': loading}" :disabled="loading">
                            <span class="fa fa-times"></span>
                             Clear
                        </button>
                    </div>
                </div>
            </div>
        </transition>

        <div class="panel panel-default with-datepicker">
            <div class="panel-heading">
                <div class="level jc-sb ai-c">
                    <span>
                        Client Imports
                    </span>
                </div>
            </div>

            <div class="panel-body">
                <client-import-form></client-import-form>
            </div>
        </div>

        <div class="panel panel-default">
            <div class="panel-heading">
                <div class="level jc-sb ai-c">
                    <span>
                        Vendor Imports
                    </span>
                </div>
            </div>

            <div class="panel-body">
                <table class="table statuses has-mobile-cards">
                    <thead>
                        <tr>
                            <th>Vendor</th>
                            <th>Type</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(status, idx) in statuses" :key="idx">
                            <td data-label="Vendor">
                                {{ status.vendor }}
                            </td>
                            <td data-label="Type">
                                {{ formatImportType(status.type) }}
                            </td>
                            <td data-label="Status" class="status">
                                <span :class="'fa ' +  statusClasses(status.status)" @click="showStatusInfo(status)"></span>
                            </td>
                            <td data-label="Queue Options">
                                <button class="btn btn-default" @click="showImportOptions(status)">
                                    <span class="fa fa-cog"></span>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="modal fade" id="modal-pending-item-info" tabindex="-1" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header error">
                        <button type="button " class="close" data-dismiss="modal" aria-hidden="true">&times;</button>

                        <h4 class="modal-title">
                            Details
                        </h4>
                    </div>
                    <div class="modal-body">
                        <h4>{{ pendingItem.vendor }}: {{ formatImportType(pendingItem.type) }}</h4>
                        <blockquote>
                            {{ pendingItem.reason }}
                        </blockquote>
                    </div>
                    <!-- Modal Actions -->
                    <div class="modal-footer">
                        <button class="btn btn-primary" @click="processQueueItem(pendingItem)">
                            <span class="fa fa-refresh"></span> Queue Import
                        </button>
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modal-status-item-info" tabindex="-1" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div :class="'modal-header ' + activeStatus.status">
                        <button type="button " class="close" data-dismiss="modal" aria-hidden="true">&times;</button>

                        <h4 class="modal-title">
                            {{ activeStatus.vendor }}: {{ formatImportType(activeStatus.type) }}
                        </h4>
                    </div>

                    <div class="modal-body" v-if="activeStatus.message !== null">
                        {{ activeStatus.message }}
                    </div>
                    <div class="modal-body" v-if="activeStatus.message === null">
                        This import has not yet ran today.
                    </div>

                    <!-- Modal Actions -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modal-status-import-options" tabindex="-1" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div :class="'modal-header ' + activeStatus.status">
                        <button type="button " class="close" data-dismiss="modal" aria-hidden="true">&times;</button>

                        <h4 class="modal-title">
                            Import {{ activeStatus.vendor }} {{ formatImportType(activeStatus.type) }} Metrics
                        </h4>
                    </div>

                    <div class="modal-body">
                        <process-import-form :vendor="activeStatus.vendor" :type="activeStatus.type"
                        ></process-import-form>
                    </div>

                    <!-- Modal Actions -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import ProcessImportForm from './ProcessImportForm.vue';
    import ClientImportForm from './ClientImportForm.vue';

    export default {
        components: { ProcessImportForm, ClientImportForm },

        props: ['user'],

        data() {
            return {
                queue: [],
                statuses: [],
                activeStatus: {
                    type: ''
                },
                pendingItem: {
                    type: ''
                },
                auth: {
                    role: 'member'
                },

                showAdminActions: false,

                loading: false
            };
        },

        computed: {
            pendingItems() {
                return this.queue.filter(item => item.status === 'pending').length > 0;
            }
        },

        created() {
            Bus.$on('import-queued', () => {
                this.getImportQueue();
                $('#modal-status-import-options').modal('hide');
            });
        },

        mounted() {
            this.prepareComponent();
            this.listen();
        },

        methods: {
            prepareComponent() {
                this.getImportQueue();
                this.getStatuses();

                this.auth.role = this.user.teams[0].pivot.role;
                this.showAdminActions = this.auth.role !== 'member';
            },

            listen() {
                let self = this;
                Echo.private('import-status')
                    .listen('ImportQueued', function(e) {
                        self.getImportQueue();
                    })
                    .listen('QueuedImportCompleted', function(e) {
                        self.getImportQueue();
                        self.getStatuses();
                    })
                    .listen('QueuedImportFailed', function(e) {
                        self.getImportQueue();
                        self.getStatuses();
                    });
            },

            getImportQueue() {
                axios.get('/api/imports/queue')
                    .then(({data}) => this.queue = data );
            },

            showPendingItemInfo(item) {
                this.pendingItem = item;
                $('#modal-pending-item-info').modal('show');
            },

            processQueueItem(item) {
                $('#modal-pending-item-info').modal('hide');
                axios.post(`/api/imports/queue/${item.id}`)
                    .then(response => {
                        console.log(response);
                        Bus.$emit('show-success-alert', response.data.message);
                        this.getImportQueue();
                    });
            },

            removeQueueItem(item) {
                $('#modal-pending-item-info').modal('hide');
                axios.delete(`/api/imports/queue/${item.id}`)
                    .then(response => {
                        Bus.$emit('show-success-alert', response.data.message);
                        this.getImportQueue();
                    });
            },

            clearQueue(item) {
                axios.delete(`/api/imports/queue/all`)
                    .then(response => {
                        Bus.$emit('show-success-alert', response.data.message);
                        this.getImportQueue();
                    });
            },

            processQueue() {
                this.loading = true;
                axios.post('/api/imports/queue/all')
                    .then(response => {
                        Bus.$emit('show-success-alert', response.data.message);
                        this.loading = false;
                        this.getImportQueue();
                    }).catch(response => {
                        console.log(response);
                        this.loading = false;
                    })
            },

            getStatuses() {
                axios.get('/api/imports/status')
                    .then(({data}) => this.statuses = data);
            },

            formatImportType(type) {
                if ( type === '' ) {
                    return;
                }
                let text = type.replace(/_/g," ");
                return text.replace(/\w\S*/g, txt => {
                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                });
            },

            statusClasses(status) {
                switch (status) {
                    case 'success':
                        return 'fa-check-circle success';
                    case 'error':
                        return 'fa-times-circle error';
                    default:
                        return 'fa-question-circle pending';
                }
            },

            showStatusInfo(status) {
                this.activeStatus = status;
                $('#modal-status-item-info').modal('show');
            },


            showImportOptions(status) {
                this.activeStatus = status;
                Bus.$emit('init-import-form', this.activeStatus.vendor);
                $('#modal-status-import-options').modal('show');
            }
        }
    }
</script>

<style scoped lang="scss">
    .fade-leave-active {
        transition: all .6s ease;
    }

    .fade-leave-active {
        opacity: 0;
    }

    .with-datepicker {
        overflow: visible;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/imports/ImportStatus.vue